/**
 * @param {number} length
 * @returns {string}
 */
function randomString (length = 8) {
  let string = ''
  const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'
  const charactersLength = characters.length

  for (let i = 0; i < length; i++) {
    string += characters.charAt(Math.floor(Math.random() * charactersLength))
  }

  return string
}

module.exports = { randomString }
